var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex-1 relative pb-8",class:_vm.overlap ? '-mt-24' : ''},[_c('div',{staticClass:"mt-8"},[_c('div',{staticClass:"mx-auto px-4 sm:px-6 lg:px-8"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }